import { useContext } from "react";
import { TourContext } from "../data/provider";

export function useTourContext() {
  const context = useContext(TourContext);

  if (context === undefined) {
    throw new Error("useTourContext must be used within a TourProvider");
  }

  return context;
}
